/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 * 
 * Environment: dev
 * Generated: 2026-07-16T08:18:14.734Z
 * Services: caseservice, facilityservice, resourceservice, routeservice
 * 
 * Note: Service-specific schemas are already prefixed (e.g., CaseService.*, ResourceService.*).
 * Common schemas that appear in multiple services are identical duplicates.
 */

export interface components {
    schemas: {
"CaseService.Domain.Contracts.Enums.GetCasesOrderBy": CaseServiceDomainContractsEnumsGetCasesOrderBy;
        /**
         * HeartPassOptionType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.CaseRandomizationResultFilter": CaseServiceDomainContractsEnumsCaseRandomizationResultFilter;
        /**
         * CaseStatus
         * @enum {string}
         */

        "Packages.Domain.Results.Error": {
            code: string | null;
            message: string | null;
            innerErrors: components["schemas"]["Packages.Domain.Results.Error"][];
            /** @deprecated */
            detailedCodes: string[];
        };
        /** ListOperationResult[ArchiveCaseModel] */

        "CaseService.ApiContracts.Models.CaseModel": {
            /** Format: uuid */
            caseId: string;
            status: components["schemas"]["CaseService.Domain.Contracts.Enums.CaseStatus"];
            customerCaseStatus: components["schemas"]["CaseService.Domain.Contracts.Enums.CustomerCaseStatus"];
            opoCaseStatus: components["schemas"]["CaseService.Domain.Contracts.Enums.OpoCaseStatus"];
            /** Format: date-time */
            initialORDateTime: string | null;
            /** Format: date-time */
            clinicalScreeningDateTime: string | null;
            /** Format: date-time */
            outcomeDateTime: string | null;
            useFixedPriceFlow: boolean | null;
            isLightsSirensRequired: boolean | null;
            /** Format: date-time */
            organOffOCSTimestamp: string | null;
            creationSide: components["schemas"]["CaseService.Domain.Contracts.Enums.CreationSide"];
            txCenterServiceApprovalStatus: components["schemas"]["CaseService.Domain.Contracts.Enums.ReviewStatus"];
            donorType: components["schemas"]["CaseService.Domain.Contracts.Enums.DonorType"];
            organType: components["schemas"]["CaseService.Domain.Contracts.Enums.OrganType"];
            serviceType: components["schemas"]["CaseService.Domain.Contracts.Enums.ServiceType"];
            serviceDetails: string | null;
            resources: components["schemas"]["CaseService.ApiContracts.Models.ResourceModel"][];
            routePlanningStatus: components["schemas"]["CaseService.Domain.Contracts.Enums.RoutePlanningStatus"];
            wasInResourcesAssignedStatus: boolean;
            /** @deprecated */
            donorHospitalDate: string | null;
            /** @deprecated */
            donorHospitalTime: string | null;
            donorHospitalTimeZone: string | null;
            /** Format: date-time */
            donorORTime: string | null;
            /** Format: uuid */
            opoId: string | null;
            opoRequest: boolean;
            isExpeditedCase: boolean;
            pediatricCase: boolean;
            reAllocationCase: boolean;
            /** Format: uuid */
            reAllocationCaseId: string | null;
            /** Format: int32 */
            reAllocationSequenceNumber: number | null;
            /** Format: uuid */
            reAllocatedToCaseId: string | null;
            /** Format: uuid */
            donorHospitalId: string | null;
            /** Format: uuid */
            txCenterId: string | null;
            donorId: string | null;
            caseName: string | null;
            txEtaHospitalDate: string | null;
            txEtaHospitalTime: string | null;
            txEtaHospitalTimeZone: string | null;
            recipientHospitalDate: string | null;
            recipientHospitalTime: string | null;
            recipientHospitalTimeZone: string | null;
            recipientHospitalORChangeReason: string | null;
            quote: components["schemas"]["CaseService.ApiContracts.Models.Quotes.QuoteModel"];
            notes: components["schemas"]["CaseService.ApiContracts.Models.NoteModel"][];
            files: components["schemas"]["CaseService.ApiContracts.Models.FileModel"][];
            routes: components["schemas"]["CaseService.ApiContracts.Models.RouteModel"][];
            assignedUsers: components["schemas"]["CaseService.ApiContracts.Models.AssignedUserModel"][];
            assignedEmployees: {
                [key: string]: components["schemas"]["CaseService.ApiContracts.Models.AssignedEmployeeModel"][];
            } | null;
            assignedCustomers: {
                [key: string]: components["schemas"]["CaseService.ApiContracts.Models.AssignedCustomerModel"][];
            } | null;
            isFavourite: boolean;
            outcomeData: components["schemas"]["CaseService.ApiContracts.Models.OutcomeDataModel"];
            delayDate: string | null;
            delayTime: string | null;
            delayTimeZone: string | null;
            delayNote: string | null;
            organAcceptanceCriteria: components["schemas"]["CaseService.ApiContracts.Models.OrganAcceptanceCriteria"];
            reviews: components["schemas"]["CaseService.ApiContracts.Models.ReviewModel"][];
            clinicalData: components["schemas"]["CaseService.ApiContracts.Models.ClinicalData.BaseClinicalDataModel"][];
            links: components["schemas"]["CaseService.ApiContracts.Models.LinkModel"][];
            organApproval: components["schemas"]["CaseService.ApiContracts.Models.OrganApprovalModel"];
            /** Format: date-time */
            createdAt: string;
            assignedOpoContacts: components["schemas"]["CaseService.ApiContracts.Models.Opo.AssignedOpoContactModel"][];
            /** Format: date-time */
            caseDeploymentStartTime: string | null;
            surgeonCaseSummary: components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.SurgeonCaseSummaryModel"];
            invoices: components["schemas"]["CaseService.ApiContracts.Models.Invoices.InvoiceModel"][];
            donorHospitalDetails: components["schemas"]["CaseService.ApiContracts.Models.DonorHospitalDetailsModel"];
            txCenterDetails: components["schemas"]["CaseService.ApiContracts.Models.TxCenterDetailsModel"];
            opoDetails: components["schemas"]["CaseService.ApiContracts.Models.OpoDetailsModel"];
            caseOutcome: components["schemas"]["CaseService.Domain.Contracts.Enums.OutcomeStatus"];
            routeComment: components["schemas"]["CaseService.ApiContracts.Models.RouteCommentModel"];
            additionalServices: boolean;
            /** Format: uuid */
            benchmarkId: string | null;
            /** Format: date-time */
            organOnOCSTimestamp: string | null;
            isServiceWithoutCoordinator: boolean | null;
            questionnaire: components["schemas"]["CaseService.ApiContracts.Models.TrialCases.AnsweredQuestionModel"][];
            isQuestionaryEditAllowed: boolean;
            trialProgram: components["schemas"]["CaseService.ApiContracts.Models.TrialCases.TrialProgramModel"];
            randomization: components["schemas"]["CaseService.ApiContracts.Models.RandomizationModel"];
            isRandomizationRequired: boolean | null;
            isRandomizationFormCompleted: boolean | null;
            reallocationData: components["schemas"]["CaseService.ApiContracts.Models.ReallocationDataModel"];
            /** Format: uuid */
            serviceRegionId: string | null;
            /** @deprecated */
            isItalian: boolean | null;
            logisticsReference: components["schemas"]["CaseService.ApiContracts.Models.LogisticsReferenceModel"];
            /** Format: uuid */
            userId: string;
            logisticsProviderType: components["schemas"]["CaseService.Domain.Contracts.Enums.LogisticsProviderType"];
            serviceRegion: components["schemas"]["CaseService.ApiContracts.Models.ServiceRegionModel"];
            caseDataSyncStatuses: components["schemas"]["CaseService.ApiContracts.Models.CaseDataSyncStatusesModel"];
            needFreezeCaseForCustomer: boolean | null;
            matchId: string | null;
            donorData: components["schemas"]["CaseService.Domain.Contracts.Models.Opo.DonorData"];
            nonStopFlightRequired: boolean | null;
        };
        /** CaseSnapshotModel */

        "CaseService.Domain.Contracts.Enums.CaseStatus": CaseServiceDomainContractsEnumsCaseStatus;
        /**
         * CauseOfDeath
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.CustomerCaseStatus": CaseServiceDomainContractsEnumsCustomerCaseStatus;
        /**
         * DeclineSourceType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.OpoCaseStatus": CaseServiceDomainContractsEnumsOpoCaseStatus;
        /**
         * OrganApprovalStatus
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.CreationSide": CaseServiceDomainContractsEnumsCreationSide;
        /**
         * CustomerCaseStatus
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.ReviewStatus": CaseServiceDomainContractsEnumsReviewStatus;
        /**
         * ReviewType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.DonorType": CaseServiceDomainContractsEnumsDonorType;
        /**
         * FlushType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.OrganType": CaseServiceDomainContractsEnumsOrganType;
        /**
         * OutcomeStatus
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.ServiceType": CaseServiceDomainContractsEnumsServiceType;
        /**
         * SupplementalOrganType
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.ResourceModel": {
            /** Format: uuid */
            resourceId: string;
            /** Format: uuid */
            resourceUserId: string | null;
            resourceType: components["schemas"]["CaseService.Domain.Contracts.Enums.ResourceType"];
            logisticsStatus: components["schemas"]["CaseService.Domain.Contracts.Enums.LogisticsStatus"];
            /** Format: uuid */
            caseResourcesReservationId: string;
            /** Format: date-time */
            caseDeploymentStartTime: string | null;
            /** Format: uuid */
            caseId: string;
            /** Format: date-time */
            bookingSentTime: string | null;
            /** Format: date-time */
            bookedAt: string | null;
            resourceData: components["schemas"]["CaseService.ApiContracts.Models.ResourceDataModel"];
        };
        /** ReviewModel */

        "CaseService.Domain.Contracts.Enums.RoutePlanningStatus": CaseServiceDomainContractsEnumsRoutePlanningStatus;
        /**
         * RouteType
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.Quotes.QuoteModel": {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            caseId: string;
            status: components["schemas"]["CaseService.Domain.Contracts.Enums.Quotes.QuoteStatus"];
            /** Format: uuid */
            quoteId: string | null;
            rejectReason: components["schemas"]["CaseService.Domain.Contracts.Enums.Quotes.QuoteRejectReason"];
            comment: components["schemas"]["CaseService.ApiContracts.Models.Quotes.QuoteCommentModel"];
            recallComment: components["schemas"]["CaseService.ApiContracts.Models.Quotes.QuoteCommentModel"];
            /** Format: date-time */
            sentToTxCenterAt: string | null;
            excludeDryRunDiscount: boolean | null;
        };
        /** RandomizationModel */

        "CaseService.ApiContracts.Models.NoteModel": {
            /** Format: uuid */
            noteId?: string;
            message: string | null;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            modifiedAt?: string;
            isPinned?: boolean;
            /** Format: uuid */
            userId: string;
            user: components["schemas"]["CaseService.ApiContracts.Models.UserModel"];
        };
        /** AssignedOpoContactModel */

        "CaseService.ApiContracts.Models.FileModel": {
            /** Format: uuid */
            id: string;
            fileName: string | null;
            path: string | null;
            /** Format: date-time */
            createdAt: string;
            signedUrl: string | null;
        };
        /** InvoiceModel */

        "CaseService.ApiContracts.Models.RouteModel": {
            /** Format: uuid */
            readonly id: string;
            /** Format: uuid */
            routeId: string;
            type: components["schemas"]["CaseService.Domain.Contracts.Enums.RouteType"];
            logisticProviders: components["schemas"]["CaseService.Domain.Contracts.Enums.LogisticProviderType"][];
        };
        /** RouteReferenceModel */

        "CaseService.ApiContracts.Models.AssignedUserModel": {
            /** Format: uuid */
            userId?: string | null;
            /** Format: uuid */
            employeeId?: string | null;
            /** Format: uuid */
            customerId?: string | null;
            user: components["schemas"]["CaseService.ApiContracts.Models.UserModel"];
            groups: components["schemas"]["CaseService.ApiContracts.Models.AssignedUserGroupModel"][];
        };
        /** BulkAssignCaseModel */

        "CaseService.ApiContracts.Models.AssignedEmployeeModel": {
            /** Format: uuid */
            userId?: string | null;
            /** Format: uuid */
            employeeId?: string | null;
            user: components["schemas"]["CaseService.ApiContracts.Models.UserModel"];
            group: string | null;
            isPrimary?: boolean | null;
            labels?: components["schemas"]["CaseService.Domain.Contracts.Enums.AssignedUserLabel"][];
        };
        /** AssignedUserGroupModel */

        "CaseService.ApiContracts.Models.AssignedCustomerModel": {
            /** Format: uuid */
            userId?: string | null;
            /** Format: uuid */
            customerId?: string | null;
            user: components["schemas"]["CaseService.ApiContracts.Models.UserModel"];
            group: string | null;
            isPrimary?: boolean | null;
            isDefaultTxUser?: boolean | null;
        };
        /** AssignedEmployeeModel */

        "CaseService.ApiContracts.Models.OutcomeDataModel": {
            /** Format: uuid */
            id: string;
            sourceType: components["schemas"]["CaseService.Domain.Contracts.Enums.DeclineSourceType"];
            outcomeType: components["schemas"]["CaseService.Domain.Contracts.Enums.OutcomeType"];
            dispositionReason: components["schemas"]["CaseService.Domain.Contracts.Enums.DispositionReasonType"];
            dispositionSpecification: components["schemas"]["CaseService.Domain.Contracts.Enums.DispositionSpecificationType"];
            dispositionComment: string | null;
            turndownOutcome: components["schemas"]["CaseService.Domain.Contracts.Enums.TurndownOutcome"];
            /** Format: date-time */
            outcomeDateTime: string | null;
        };
        /** PatchAssignedUsersAction */

        "CaseService.ApiContracts.Models.OrganAcceptanceCriteria": {
            /** Format: int32 */
            totalExtubationTime: number | null;
            /** Format: int32 */
            systolicTimeInitiation: number | null;
            /** Format: int32 */
            saturationTimeInitiation: number | null;
            clockRestarts: boolean | null;
            warmIschemicTimeEnds: string | null;
            /** Format: int32 */
            totalWarmIschemicTime: number | null;
            extraDonorTissueRequests: string | null;
            /** Format: int32 */
            warmIschemicTime: number | null;
            warmIschemicTimeType: components["schemas"]["CaseService.Domain.Contracts.Enums.WarmIschemicTimeType"];
            /** Format: int32 */
            fromExtubationToColdFlush: number | null;
            biopsyType: components["schemas"]["CaseService.Domain.Contracts.Enums.AcceptanceCriteriaBiopsyType"];
        };
        /** OrganApprovalModel */

        "CaseService.ApiContracts.Models.ReviewModel": {
            /** Format: uuid */
            id: string;
            status: components["schemas"]["CaseService.Domain.Contracts.Enums.ReviewStatus"];
            type: components["schemas"]["CaseService.Domain.Contracts.Enums.ReviewType"];
            reviewerType: components["schemas"]["CaseService.Domain.Contracts.Enums.ReviewerType"];
            /** Format: uuid */
            reviewerUserId: string;
            reviewerFirstName: string | null;
            reviewerLastName: string | null;
            reviewerLogoUrl: string | null;
            comment: string | null;
            /** Format: date-time */
            reviewedAt: string;
        };
        /** RouteCommentModel */

        "CaseService.ApiContracts.Models.ClinicalData.BaseClinicalDataModel": {
            clinicalItemType: components["schemas"]["CaseService.Domain.Contracts.Enums.ApiContractClinicalItemType"];
        };
        /** MediaFileModel */

        "CaseService.ApiContracts.Models.LinkModel": {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            userId: string;
            url: string | null;
            description?: string | null;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            modifiedAt?: string;
        };
        /** Location */

        "CaseService.ApiContracts.Models.OrganApprovalModel": {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            caseId: string;
            /** Format: uuid */
            requestorUserId: string;
            /** Format: uuid */
            reviewerUserId: string | null;
            status: components["schemas"]["CaseService.Domain.Contracts.Enums.OrganApprovalStatus"];
            organType: components["schemas"]["CaseService.Domain.Contracts.Enums.OrganType"];
            declineReason: components["schemas"]["CaseService.Domain.Contracts.Enums.OrganOnOcsDeclineReason"];
            /** Format: date-time */
            approvedAt: string | null;
            /** Format: date-time */
            declinedAt: string | null;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            modifiedAt: string;
        };
        /** OutcomeDataModel */

        "CaseService.ApiContracts.Models.Opo.AssignedOpoContactModel": {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            userId?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            email?: string | null;
            primaryPhone: string | null;
            secondaryPhone?: string | null;
            isPrimary?: boolean;
            isOpoUser?: boolean;
            roles?: string[];
            organizations?: components["schemas"]["CaseService.ApiContracts.Models.Opo.AssignedOpoContactOrganizationModel"][];
            parent?: components["schemas"]["CaseService.ApiContracts.Models.Opo.OpoModel"];
            photoPath?: string | null;
        };
        /** AssignedOpoContactOrganizationModel */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.SurgeonCaseSummaryModel": {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            caseId: string;
            /** Format: uuid */
            userId: string;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            modifiedAt: string;
            summary: components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.ISurgeonCaseSummaryDataModel"];
        };
        /** AnsweredQuestionModel */

        "CaseService.ApiContracts.Models.Invoices.InvoiceModel": {
            /** Format: uuid */
            id: string;
            fileName: string | null;
            status: components["schemas"]["CaseService.Domain.Contracts.Enums.InvoiceStatus"];
        };
        /** LinkModel */

        "CaseService.ApiContracts.Models.DonorHospitalDetailsModel": {
            /** Format: uuid */
            id: string;
            name: string | null;
            code: string | null;
            location: components["schemas"]["CaseService.ApiContracts.Models.Location"];
            logoPath?: string | null;
        };
        /** DuplicateCaseModel */

        "CaseService.ApiContracts.Models.TxCenterDetailsModel": {
            /** Format: uuid */
            id: string;
            name: string | null;
            code: string | null;
            location: components["schemas"]["CaseService.ApiContracts.Models.Location"];
            qadCustomerId?: string | null;
            hasFixedPriceContract?: boolean | null;
            logoPath?: string | null;
            trialPrograms?: components["schemas"]["CaseService.ApiContracts.Models.TrialCases.TrialProgramModel"][];
            nonStopFlightAllowed?: boolean | null;
        };
        /** UserModel */

        "CaseService.ApiContracts.Models.OpoDetailsModel": {
            /** Format: uuid */
            id: string;
            name: string | null;
            code: string | null;
            location: components["schemas"]["CaseService.ApiContracts.Models.Location"];
        };
        /** OrganAcceptanceCriteria */

        "CaseService.Domain.Contracts.Enums.OutcomeStatus": CaseServiceDomainContractsEnumsOutcomeStatus;
        /**
         * OutcomeType
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.RouteCommentModel": {
            comment: string | null;
            /** Format: uuid */
            userId: string;
        };
        /** RouteModel */

        "CaseService.ApiContracts.Models.TrialCases.AnsweredQuestionModel": {
            question: components["schemas"]["CaseService.Domain.Contracts.Enums.Question"];
            answer: components["schemas"]["CaseService.Domain.Contracts.Enums.Answer"];
            customAnswer: string | null;
        };
        /** TrialProgramModel */

        "CaseService.ApiContracts.Models.TrialCases.TrialProgramModel": {
            /** Format: uuid */
            id?: string;
            name: string | null;
            organ?: components["schemas"]["CaseService.Domain.Contracts.Enums.OrganType"];
            isActive?: boolean;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            modifiedAt?: string;
        };
        /** TxCenterDetailsModel */

        "CaseService.ApiContracts.Models.RandomizationModel": {
            /** Format: date-time */
            randomizationDateTime: string;
            timeZone: string | null;
            txCenterRepresentativeName: string | null;
            /** Format: uuid */
            txCenterId: string;
            result: components["schemas"]["CaseService.Domain.Contracts.Enums.RandomizationResult"];
            isFromReAllocation: boolean;
        };
        /** ReallocationDataModel */

        "CaseService.ApiContracts.Models.ReallocationDataModel": {
            /** Format: uuid */
            caseId: string;
            /** Format: uuid */
            reAllocationCaseId: string | null;
            /** Format: int32 */
            reAllocationSequenceNumber: number | null;
            /** Format: uuid */
            reAllocatedToCaseId: string | null;
            creationSide: components["schemas"]["CaseService.Domain.Contracts.Enums.CreationSide"];
            outcomeData: components["schemas"]["CaseService.ApiContracts.Models.OutcomeDataModel"];
            trialProgram: components["schemas"]["CaseService.ApiContracts.Models.TrialCases.TrialProgramModel"];
            questionnaire: components["schemas"]["CaseService.ApiContracts.Models.TrialCases.AnsweredQuestionModel"][];
            randomization: components["schemas"]["CaseService.ApiContracts.Models.RandomizationModel"];
        };
        /** ResourceDataModel */

        "CaseService.ApiContracts.Models.LogisticsReferenceModel": {
            /** Format: uuid */
            id: string;
            routes: components["schemas"]["CaseService.ApiContracts.Models.RouteReferenceModel"][];
        };
        /** NoteModel */

        "CaseService.Domain.Contracts.Enums.LogisticsProviderType": CaseServiceDomainContractsEnumsLogisticsProviderType;
        /**
         * LogisticsStatus
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.ServiceRegionModel": {
            /** Format: uuid */
            id: string;
            name: string | null;
            countries?: components["schemas"]["CaseService.ApiContracts.Models.CountryModel"][];
        };
        /** CreateHeartSurgeonCaseSummaryDataModel */

        "CaseService.ApiContracts.Models.CaseDataSyncStatusesModel": {
            clinicalDataSyncStatus: components["schemas"]["CaseService.Domain.Contracts.Enums.CaseDataSyncStatus"];
            inventorySyncStatus: components["schemas"]["CaseService.Domain.Contracts.Enums.CaseDataSyncStatus"];
            clinicalResourcesSyncStatus: components["schemas"]["CaseService.Domain.Contracts.Enums.CaseDataSyncStatus"];
        };
        /** ActivityDetails */

        "CaseService.Domain.Contracts.Models.Opo.DonorData": {
            donorDemographics: components["schemas"]["CaseService.Domain.Contracts.Models.Opo.DonorDemographics"];
            donorParameters: components["schemas"]["CaseService.Domain.Contracts.Models.Opo.DonorParameters"];
            donorBlood: components["schemas"]["CaseService.Domain.Contracts.Models.Opo.DonorBlood"];
            reasonForUnallocated: string | null;
            liverData: components["schemas"]["CaseService.Domain.Contracts.Models.Opo.LiverData"];
            heartData: components["schemas"]["CaseService.Domain.Contracts.Models.Opo.HeartData"];
            lungData: components["schemas"]["CaseService.Domain.Contracts.Models.Opo.LungData"];
        };
        /** DonorDemographics */

        "CaseService.Domain.Contracts.Enums.ResourceType": CaseServiceDomainContractsEnumsResourceType;
        /**
         * ReviewStatus
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.LogisticsStatus": CaseServiceDomainContractsEnumsLogisticsStatus;
        /**
         * Lung
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.ResourceDataModel": {
            resourceType: components["schemas"]["CaseService.Domain.Contracts.Enums.ResourceType"];
            /** Format: uuid */
            id: string | null;
            firstName: string | null;
            lastName: string | null;
            email: string | null;
            phone: string | null;
            enabled: boolean | null;
            type: components["schemas"]["CaseService.Domain.Contracts.Enums.UserType"];
            roles: string[];
            profilePhoto: string | null;
            resourceName: string | null;
            serialNumber: string | null;
            fullSerialNumber: string | null;
            tailNumber: string | null;
            /** Format: uuid */
            employeeId: string | null;
            trialPrograms: components["schemas"]["CaseService.ApiContracts.Models.TrialCases.TrialProgramModel"][];
            labels: components["schemas"]["CaseService.Domain.Contracts.Enums.ResourceLabel"][];
        };
        /** ResourceModel */

        "CaseService.Domain.Contracts.Enums.Quotes.QuoteStatus": CaseServiceDomainContractsEnumsQuotesQuoteStatus;
        /**
         * RadiometerType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.Quotes.QuoteRejectReason": CaseServiceDomainContractsEnumsQuotesQuoteRejectReason;
        /**
         * QuoteStatus
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.Quotes.QuoteCommentModel": {
            comment: string | null;
            /** Format: uuid */
            userId: string;
        };
        /** QuoteModel */

        "CaseService.ApiContracts.Models.UserModel": {
            /** Format: uuid */
            id: string | null;
            firstName: string | null;
            lastName: string | null;
            photoPath: string | null;
            email: string | null;
            phone: string | null;
            secondaryPhone: string | null;
            enabled: boolean | null;
            type: components["schemas"]["CaseService.Domain.Contracts.Enums.UserType"];
            userTypes: components["schemas"]["CaseService.Domain.Contracts.Enums.UserType"][];
            roles: string[];
            /** Format: uuid */
            employeeId: string | null;
            /** Format: uuid */
            customerId: string | null;
            /** Format: uuid */
            opoContactId: string | null;
            readonly isSystemUser: boolean;
        };
        /** GrantAccessTicketRequest */

        "CaseService.Domain.Contracts.Enums.RouteType": CaseServiceDomainContractsEnumsRouteType;
        /**
         * ServiceOutcomeType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.LogisticProviderType": CaseServiceDomainContractsEnumsLogisticProviderType;
        /**
         * LogisticsProviderType
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.AssignedUserGroupModel": {
            group: string | null;
            isPrimary?: boolean | null;
        };
        /** AssignedUserModel */

        "CaseService.Domain.Contracts.Enums.AssignedUserLabel": CaseServiceDomainContractsEnumsAssignedUserLabel;
        /**
         * AssistanceType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.DeclineSourceType": CaseServiceDomainContractsEnumsDeclineSourceType;
        /**
         * DispositionReasonType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.OutcomeType": CaseServiceDomainContractsEnumsOutcomeType;
        /**
         * PatchAssignedUsersActionType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.DispositionReasonType": CaseServiceDomainContractsEnumsDispositionReasonType;
        /**
         * DispositionSpecificationType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.DispositionSpecificationType": CaseServiceDomainContractsEnumsDispositionSpecificationType;
        /**
         * DomainAcceptanceCriteriaBiopsyType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.TurndownOutcome": CaseServiceDomainContractsEnumsTurndownOutcome;
        /**
         * UserType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.WarmIschemicTimeType": CaseServiceDomainContractsEnumsWarmIschemicTimeType;
        /**
         * WithdrawalOfLifeSupportType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.AcceptanceCriteriaBiopsyType": CaseServiceDomainContractsEnumsAcceptanceCriteriaBiopsyType;
        /**
         * Answer
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.ReviewType": CaseServiceDomainContractsEnumsReviewType;
        /**
         * ReviewerType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.ReviewerType": CaseServiceDomainContractsEnumsReviewerType;
        /**
         * RoutePlanningStatus
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.ApiContractClinicalItemType": CaseServiceDomainContractsEnumsApiContractClinicalItemType;
        /**
         * AssignedUserLabel
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.OrganApprovalStatus": CaseServiceDomainContractsEnumsOrganApprovalStatus;
        /**
         * OrganOnOcsDeclineReason
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.OrganOnOcsDeclineReason": CaseServiceDomainContractsEnumsOrganOnOcsDeclineReason;
        /**
         * OrganType
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.Opo.AssignedOpoContactOrganizationModel": {
            /** Format: uuid */
            id?: string;
            name: string | null;
            code: string | null;
            location: components["schemas"]["CaseService.ApiContracts.Models.Opo.LocationModel"];
            isPrimary?: boolean;
            roles?: string[];
        };
        /** AssignedOpoUserModel */

        "CaseService.ApiContracts.Models.Opo.OpoModel": {
            /** Format: uuid */
            id?: string;
            name: string | null;
            code: string | null;
            location: components["schemas"]["CaseService.ApiContracts.Models.Opo.LocationModel"];
        };
        /** UpdateDonorDataRequest */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.ISurgeonCaseSummaryDataModel": components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.Heart.CreateHeartSurgeonCaseSummaryDataModel"] | components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.CreateLiverSurgeonCaseSummaryDataModel"];
        /** AberrantAnatomyTypeDataModel */

        "CaseService.Domain.Contracts.Enums.InvoiceStatus": CaseServiceDomainContractsEnumsInvoiceStatus;
        /**
         * LiverAnatomyType
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.Location": {
            /** Format: uuid */
            id: string;
            country: string | null;
            region: string | null;
            state: string | null;
            city: string | null;
            addressLine: string | null;
            postalCode: string | null;
            timezone: string | null;
            /** Format: double */
            latitude: number | null;
            /** Format: double */
            longitude: number | null;
        };
        /** LogisticsReferenceModel */

        "CaseService.Domain.Contracts.Enums.Question": CaseServiceDomainContractsEnumsQuestion;
        /**
         * QuoteRejectReason
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.Answer": CaseServiceDomainContractsEnumsAnswer;
        /**
         * ApiContractClinicalItemType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.RandomizationResult": CaseServiceDomainContractsEnumsRandomizationResult;
        /**
         * ResourceLabel
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.RouteReferenceModel": {
            /** Format: uuid */
            id: string;
            type: components["schemas"]["CaseService.Domain.Contracts.Enums.RouteType"];
        };
        /** ServiceRegionModel */

        "CaseService.ApiContracts.Models.CountryModel": {
            /** Format: uuid */
            id?: string;
            code: string | null;
            name: string | null;
        };
        /** CreateCaseRequest */

        "CaseService.Domain.Contracts.Enums.CaseDataSyncStatus": CaseServiceDomainContractsEnumsCaseDataSyncStatus;
        /**
         * CaseRandomizationResultFilter
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Models.Opo.DonorDemographics": {
            /** Format: int32 */
            age: number | null;
            /** Format: double */
            weight: number | null;
            /** Format: double */
            height: number | null;
            gender: components["schemas"]["CaseService.Domain.Contracts.Enums.DonorGender"];
            causeOfDeath: components["schemas"]["CaseService.Domain.Contracts.Enums.CauseOfDeath"];
        };
        /** DonorParameters */

        "CaseService.Domain.Contracts.Models.Opo.DonorParameters": {
            neuroStatus: components["schemas"]["CaseService.Domain.Contracts.Enums.NeuroStatus"];
            vasopressors: boolean | null;
            sustainedHypotension: boolean | null;
        };
        /** HeartData */

        "CaseService.Domain.Contracts.Models.Opo.DonorBlood": {
            abo: components["schemas"]["CaseService.Domain.Contracts.Enums.BloodGroupAbo"];
            positiveSerologies: string | null;
        };
        /** DonorData */

        "CaseService.Domain.Contracts.Models.Opo.LiverData": {
            /** Format: double */
            totalBilirubinRecentResult1: number | null;
            /** Format: double */
            totalBilirubinRecentResult2: number | null;
            /** Format: double */
            aspartateAminotransferaseRecentResult1: number | null;
            /** Format: double */
            aspartateAminotransferaseRecentResult2: number | null;
            /** Format: double */
            alanineAminotransferaseRecentResult1: number | null;
            /** Format: double */
            alanineAminotransferaseRecentResult2: number | null;
            ctImagingResultsUrl: string | null;
            willLocalSurgeonPerformOrganProcurement: boolean | null;
            sedation: string | null;
        };
        /** LungData */

        "CaseService.Domain.Contracts.Models.Opo.HeartData": {
            matchRunOcsCenterNames: string | null;
        };
        /** LiverData */

        "CaseService.Domain.Contracts.Models.Opo.LungData": {
            matchRunOcsCenterNames: string | null;
            /** Format: double */
            mostRecentPfRatio: number | null;
            /** Format: int32 */
            netFluidBalanceOverPast24Hours: number | null;
            cultureSensitivityResults: string | null;
            ctImagingResultsUrl: string | null;
            sedation: string | null;
        };
        /** OpoContactIdIsPrimaryPair */

        "CaseService.Domain.Contracts.Enums.UserType": CaseServiceDomainContractsEnumsUserType;
        /**
         * WarmIschemicTimeType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.ResourceLabel": CaseServiceDomainContractsEnumsResourceLabel;
        /**
         * ResourceType
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.Opo.LocationModel": {
            /** Format: uuid */
            id?: string;
            country: string | null;
            region?: string | null;
            state?: string | null;
            city?: string | null;
            addressLine?: string | null;
            postalCode?: string | null;
            timezone: string | null;
            /** Format: double */
            latitude?: number | null;
            /** Format: double */
            longitude?: number | null;
        };
        /** OpoModel */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.Heart.CreateHeartSurgeonCaseSummaryDataModel": {
            status: components["schemas"]["CaseService.Domain.Contracts.Enums.SurgeonCaseSummaryStatus"];
            isSurgicalInjuryOccurred: boolean;
            isOrganNotUsed: boolean | null;
            challengeDescription: string | null;
            /** Format: date-time */
            dateTime: string | null;
            dateTimeZone: string | null;
        };
        /** ISurgeonCaseSummaryDataModel */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.CreateLiverSurgeonCaseSummaryDataModel": {
            status: components["schemas"]["CaseService.Domain.Contracts.Enums.SurgeonCaseSummaryStatus"];
            generalCaseDetails: components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.GeneralCaseDetailsModel"];
            times: components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.TimesModel"];
            vessels: components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.VesselsModel"];
            procurementInjury: components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.ProcurementInjuryModel"];
            kidneyProcurement: components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.KidneyProcurementModel"];
            assistance: components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.AssistanceModel"];
            summary: components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.SummaryModel"];
            /** Format: date-time */
            dateTime: string | null;
            dateTimeZone: string | null;
        };
        /** GeneralCaseDetailsModel */

        "CaseService.Domain.Contracts.Enums.DonorGender": CaseServiceDomainContractsEnumsDonorGender;
        /**
         * DonorType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.CauseOfDeath": CaseServiceDomainContractsEnumsCauseOfDeath;
        /**
         * ClinicalItemType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.NeuroStatus": CaseServiceDomainContractsEnumsNeuroStatus;
        /**
         * NoLiverInjuryType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.BloodGroupAbo": CaseServiceDomainContractsEnumsBloodGroupAbo;
        /**
         * CaseActivityStatus
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.SurgeonCaseSummaryStatus": CaseServiceDomainContractsEnumsSurgeonCaseSummaryStatus;
        /**
         * TurndownOutcome
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.GeneralCaseDetailsModel": {
            unosID: string | null;
            /** Format: date-time */
            date: string;
            dateTimeZone: string | null;
            donorType: components["schemas"]["CaseService.Domain.Contracts.Enums.DonorType"];
            isDonorExpiredInTime: boolean;
            liverQuality: components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.LiverQualityDataModel"];
            /** Format: double */
            estimatedSteatosis: number | null;
            flush: components["schemas"]["CaseService.Domain.Contracts.Enums.FlushType"];
            liverOutcome: components["schemas"]["CaseService.Domain.Contracts.Enums.LiverOutcome"];
            /** Format: date-time */
            warmIschemiaTime: string | null;
            warmIschemiaTimeTimeZone: string | null;
        };
        /** KidneyProcurementModel */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.TimesModel": {
            /** Format: date-time */
            skinIncision: string | null;
            skinIncisionTimeZone: string | null;
            /** Format: date-time */
            crossClampAndFlush: string | null;
            crossClampAndFlushTimeZone: string | null;
            /** Format: date-time */
            hepatectomyCompletion: string | null;
            hepatectomyCompletionTimeZone: string | null;
            /** Format: date-time */
            backTableDissectionAndLiverCannulationCompletion: string | null;
            backTableDissectionAndLiverCannulationCompletionTimeZone: string | null;
        };
        /** VesselsModel */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.VesselsModel": {
            aberrantArterialAnatomy: boolean | null;
            aberrantAnatomyTypeData: components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.AberrantAnatomyTypeDataModel"];
            reconstructionDescription: string | null;
            mediaFiles: components["schemas"]["CaseService.ApiContracts.Models.ClinicalData.Media.MediaFileModel"][];
        };
        /** SurgeonCaseSummaryModel */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.ProcurementInjuryModel": {
            anyProcurementOrBackTableInjuries: boolean | null;
            procurementInjuryTypeData: components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.ProcurementInjuryTypeDataModel"];
            backtableInjuries: components["schemas"]["CaseService.Domain.Contracts.Enums.BacktableInjuryType"][];
            noLiverInjuryTypeData: components["schemas"]["CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.NoLiverInjuryTypeDataModel"];
            details: string | null;
            mediaFiles: components["schemas"]["CaseService.ApiContracts.Models.ClinicalData.Media.MediaFileModel"][];
            impactOfInjury: components["schemas"]["CaseService.Domain.Contracts.Enums.ImpactOfInjuryType"];
        };
        /** ProcurementInjuryTypeDataModel */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.KidneyProcurementModel": {
            isKidneysProcuredForTransplantAfterOpoRequest: boolean | null;
            opoName: string | null;
            mediaFiles: components["schemas"]["CaseService.ApiContracts.Models.ClinicalData.Media.MediaFileModel"][];
        };
        /** LiverQualityDataModel */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.AssistanceModel": {
            assistanceInTheDonor: components["schemas"]["CaseService.Domain.Contracts.Enums.AssistanceType"][];
            backtablePreparationAssistance: components["schemas"]["CaseService.Domain.Contracts.Enums.AssistanceType"][];
        };
        /** CreateLiverSurgeonCaseSummaryDataModel */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.SummaryModel": {
            mediaFiles: components["schemas"]["CaseService.ApiContracts.Models.ClinicalData.Media.MediaFileModel"][];
            text: string | null;
        };
        /** TimesModel */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.LiverQualityDataModel": {
            liverQualities: components["schemas"]["CaseService.Domain.Contracts.Enums.LiverQuality"][];
            text: string | null;
        };
        /** NoLiverInjuryTypeDataModel */

        "CaseService.Domain.Contracts.Enums.FlushType": CaseServiceDomainContractsEnumsFlushType;
        /**
         * GetArchiveCasesOrderBy
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.LiverOutcome": CaseServiceDomainContractsEnumsLiverOutcome;
        /**
         * LiverQuality
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.AberrantAnatomyTypeDataModel": {
            aberrantAnatomyTypes: components["schemas"]["CaseService.Domain.Contracts.Enums.AberrantAnatomyType"][];
            text: string | null;
        };
        /** AssistanceModel */

        "CaseService.ApiContracts.Models.ClinicalData.Media.MediaFileModel": {
            /** Format: uuid */
            id?: string | null;
            /** Format: uuid */
            fileId: string;
            fileName: string | null;
            path: string | null;
            details?: string | null;
            /** Format: float */
            duration?: number | null;
            mediaType?: components["schemas"]["CaseService.Domain.Contracts.Enums.MediaType"];
            preview?: components["schemas"]["CaseService.ApiContracts.Models.ClinicalData.Media.PreviewModel"];
        };
        /** PreviewModel */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.ProcurementInjuryTypeDataModel": {
            procurementInjuries: components["schemas"]["CaseService.Domain.Contracts.Enums.ProcurementInjuryType"][];
            text: string | null;
        };
        /** SummaryModel */

        "CaseService.Domain.Contracts.Enums.BacktableInjuryType": CaseServiceDomainContractsEnumsBacktableInjuryType;
        /**
         * BloodFromType
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.SurgeonCaseSummary.Liver.NoLiverInjuryTypeDataModel": {
            noLiverInjuries: components["schemas"]["CaseService.Domain.Contracts.Enums.NoLiverInjuryType"][];
            text: string | null;
        };
        /** ProcurementInjuryModel */

        "CaseService.Domain.Contracts.Enums.ImpactOfInjuryType": CaseServiceDomainContractsEnumsImpactOfInjuryType;
        /**
         * InventoryPartType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.AssistanceType": CaseServiceDomainContractsEnumsAssistanceType;
        /**
         * BacktableInjuryType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.LiverQuality": CaseServiceDomainContractsEnumsLiverQuality;
        /**
         * LiverReconstructionType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.AberrantAnatomyType": CaseServiceDomainContractsEnumsAberrantAnatomyType;
        /**
         * AcceptanceCriteriaBiopsyType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.MediaType": CaseServiceDomainContractsEnumsMediaType;
        /**
         * NRPType
         * @enum {string}
         */

        "CaseService.ApiContracts.Models.ClinicalData.Media.PreviewModel": {
            /** Format: uuid */
            fileId: string;
            fileName: string | null;
            path: string | null;
            /** Format: float */
            duration?: number | null;
            mediaType?: components["schemas"]["CaseService.Domain.Contracts.Enums.MediaType"];
        };
        /** DoubleLungFlushModel */

        "CaseService.Domain.Contracts.Enums.ProcurementInjuryType": CaseServiceDomainContractsEnumsProcurementInjuryType;
        /**
         * ProvidedServiceType
         * @enum {string}
         */

        "CaseService.Domain.Contracts.Enums.NoLiverInjuryType": CaseServiceDomainContractsEnumsNoLiverInjuryType;
        /**
         * OpoCaseActivityStatus
         * @enum {string}
         */

        "FacilityService.ApiContracts.Inputs.Create.CreateHubInput": {
            name: string | null;
            code: string | null;
            country: string | null;
            state: string | null;
            city: string | null;
            addressLine: string | null;
            postalCode: string | null;
            timezone: string | null;
            /** Format: double */
            latitude: number | null;
            /** Format: double */
            longitude: number | null;
            /** Format: uuid */
            nationalManagerId: string | null;
            /** Format: uuid */
            regionalManagerId: string | null;
            isSuperHub: boolean;
            /** Format: uuid */
            regionId: string | null;
        };
        /** GetNearestAirportsInput */

        "FacilityService.ApiContracts.Inputs.Get.GetNearestAirportsInput": {
            aircraftLocations: components["schemas"]["FacilityService.Application.Contracts.Airports.Queries.AircraftLocation"][];
        };
        /** PatchHubInput */

        "FacilityService.Application.Contracts.Airports.Queries.AircraftLocation": {
            /** Format: uuid */
            aircraftId: string;
            /** Format: double */
            longitude: number;
            /** Format: double */
            latitude: number;
        };
        /**
         * AirportOrderByOptions
         * @enum {string}
         */

        "FacilityService.Application.Contracts.Airports.Queries.NearestAirportView": {
            /** Format: uuid */
            aircraftId: string;
            nearestAirport: components["schemas"]["FacilityService.Application.Contracts.Airports.Queries.AirportView"];
        };
        /**
         * LocationRelatedOrderByOptions
         * @enum {string}
         */

        "FacilityService.Application.Contracts.Airports.Queries.AirportView": {
            /** Format: uuid */
            id: string;
            /** Format: int32 */
            maoId: number;
            name: string | null;
            icao: string | null;
            iata: string | null;
            faa: string | null;
            location: components["schemas"]["FacilityService.Application.Contracts.Common.Queries.LocationView"];
            fbos: components["schemas"]["FacilityService.Application.Contracts.Fbos.Queries.FboView"][];
            isSabreSupported: boolean;
        };
        /** NearestAirportView */

        "FacilityService.Application.Contracts.Common.Queries.LocationView": {
            /** Format: uuid */
            id: string;
            country: string | null;
            /** Format: uuid */
            regionId: string | null;
            region: string | null;
            state: string | null;
            city: string | null;
            addressLine: string | null;
            postalCode: string | null;
            timezone: string | null;
            /** Format: double */
            latitude: number | null;
            /** Format: double */
            longitude: number | null;
        };
        /** FboAddressView */

        "FacilityService.Application.Contracts.Fbos.Queries.FboView": {
            /** Format: uuid */
            id: string;
            /** Format: int32 */
            maoId: number;
            /** Format: int32 */
            airportId: number;
            name: string | null;
            organizationName: string | null;
            addresses: components["schemas"]["FacilityService.Application.Contracts.Fbos.Queries.FboAddressView"][];
            contactMethods: components["schemas"]["FacilityService.Application.Contracts.Fbos.Queries.FboContactMethodView"][];
        };
        /** HubFullView */

        "FacilityService.Application.Contracts.Fbos.Queries.FboAddressView": {
            /** Format: int32 */
            id: number;
            isPrimary: boolean;
            type: string | null;
            addressLine1: string | null;
            addressLine2: string | null;
            city: string | null;
        };
        /** FboContactMethodView */

        "FacilityService.Application.Contracts.Fbos.Queries.FboContactMethodView": {
            /** Format: int32 */
            id: number;
            type: string | null;
            subType: string | null;
            content: string | null;
            comment: string | null;
            isPrimary: boolean;
        };
        /** FboView */

"ResourceService.Domain.Contracts.Enums.Organ": ResourceServiceDomainContractsEnumsOrgan;
        /**
         * ResourceStatus
         * @enum {string}
         */

        "ResourceService.Domain.Contracts.Enums.Status": ResourceServiceDomainContractsEnumsStatus;
        /**
         * AutoSchedulerInfo
         * @description Contains auto scheduler solution metadata.
         */

        "ResourceService.Domain.Contracts.Enums.EmployeeSearchOrderBy": ResourceServiceDomainContractsEnumsEmployeeSearchOrderBy;
        /**
         * GccEmployeeSearchOrderBy
         * @description Defines the sortable fields that can be applied to a GCC employee search.
         * @enum {string}
         */

        "ResourceService.Domain.Contracts.Enums.AffiliationType": ResourceServiceDomainContractsEnumsAffiliationType;
        /**
         * AircraftOrderBy
         * @enum {string}
         */

        "ResourceService.ApiContracts.Employees.Requests.PatchOwnEmployeeRequest": {
            /** Format: float */
            weight: number | null;
            scrubSizeTop: components["schemas"]["ResourceService.Domain.Contracts.Enums.Size"];
            scrubSizeBottom: components["schemas"]["ResourceService.Domain.Contracts.Enums.Size"];
            tsaPrecheckNumber: string | null;
            phone: string | null;
            /** Format: uuid */
            baseLocation: string | null;
            /** Format: uuid */
            homeLocation: string | null;
            /** Format: int32 */
            closestAirportForDeployment: number | null;
            locationPreference: components["schemas"]["ResourceService.Domain.Contracts.Enums.LocationPreference"];
            organSpecializations: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            canWorkOnExtraShifts: boolean | null;
            /** Format: int32 */
            extraShiftsCount: number | null;
            canTravel: boolean | null;
            /** Format: int32 */
            travelShiftsCount: number | null;
            affiliationType: components["schemas"]["ResourceService.Domain.Contracts.Enums.AffiliationType"];
            /** Format: uuid */
            affiliationId: string | null;
            contractorCertifications: components["schemas"]["ResourceService.ApiContracts.Employees.ContractorCertificationModel"][];
            clinicalCoordinatorType: components["schemas"]["ResourceService.Domain.Contracts.Scheduler.Enums.CCResourceType"];
            clinicalSpecialistShiftGroupType: components["schemas"]["ResourceService.Domain.Contracts.Scheduler.Enums.CSHolidayDutyGroup"];
            /** Format: uuid */
            liverSurgeonRegionId: string | null;
            /** Format: uuid */
            heartLungsSurgeonRegionId: string | null;
            phoneSupportOrganSpecializations: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            organManagementSpecialistSpecializations: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            proctorOrganSpecializations: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            shadowOrganSpecializations: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            profilePhoto: string | null;
        };
        /** TrackEmployeeLocationRequest */

        "ResourceService.Application.Contracts.Scheduler.Queries.Surgeon.GetSRegions": Record<string, never>;
        /**
         * CCMyScheduleSegment
         * @description Clinical specialist schedule for a specific period for the clinical specialist viewing the schedule.
         */

        "ResourceService.Application.Models.OcsConsole.CreateOcsConsoleRequest": {
            ocsConsoleName: string | null;
            serialNumber: string | null;
            /** Format: uuid */
            nopHub: string;
            organType: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"];
            isInMaintenance?: boolean;
            logoPath?: string | null;
            /** Format: uuid */
            trialProgramId?: string | null;
        };
        /**
         * OcsConsoleSearchOrderBy
         * @enum {string}
         */

        "ResourceService.Domain.Contracts.Enums.Size": ResourceServiceDomainContractsEnumsSize;
        /**
         * Status
         * @enum {string}
         */

        "ResourceService.Domain.Contracts.Enums.LocationPreference": ResourceServiceDomainContractsEnumsLocationPreference;
        /**
         * OcsConsoleStatus
         * @enum {string}
         */

        "ResourceService.ApiContracts.Employees.ContractorCertificationModel": {
            organType: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"];
            /** Format: date-time */
            certificationDate: string;
        };
        /** PatchEmployeeRequest */

        "ResourceService.Domain.Contracts.Scheduler.Enums.CCResourceType": ResourceServiceDomainContractsSchedulerEnumsCCResourceType;
        /**
         * CCShiftType
         * @description Type of clinical coordinator shift.
         * @enum {string}
         */

        "ResourceService.Domain.Contracts.Scheduler.Enums.CSHolidayDutyGroup": ResourceServiceDomainContractsSchedulerEnumsCSHolidayDutyGroup;
        /**
         * CSShiftType
         * @description Type of clinical specialist shift.
         * @enum {string}
         */

        "ResourceService.Application.Contracts.Employees.EmployeeData": {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            userId?: string | null;
            /** Format: int32 */
            workdayId?: number | null;
            /** Format: uuid */
            azureAdId?: string | null;
            firstName: string | null;
            lastName: string | null;
            email: string | null;
            phone?: string | null;
            businessPhone?: string | null;
            department?: string | null;
            profilePhoto?: string | null;
            position?: string | null;
            roles?: string[];
            /** Format: date */
            hireDate?: string | null;
            /** Format: date-time */
            workdayTerminationDate?: string | null;
            /** Format: float */
            weight?: number | null;
            scrubSizeTop?: components["schemas"]["ResourceService.Domain.Contracts.Enums.Size"];
            scrubSizeBottom?: components["schemas"]["ResourceService.Domain.Contracts.Enums.Size"];
            tsaPrecheckNumber?: string | null;
            /** Format: uuid */
            baseLocation?: string | null;
            /** Format: uuid */
            homeLocation?: string | null;
            /** Format: uuid */
            currentLocation?: string | null;
            /** Format: int32 */
            closestAirportForDeployment?: number | null;
            locationPreference?: components["schemas"]["ResourceService.Domain.Contracts.Enums.LocationPreference"];
            /** Format: date */
            dateOfBirth?: string | null;
            isActive?: boolean;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            modifiedAt?: string;
            organSpecializations?: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            phoneSupportOrganSpecializations?: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            rsScheduleManagerOrgans?: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            organManagementSpecialistSpecializations?: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            proctorOrganSpecializations?: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            shadowOrganSpecializations?: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            reservations?: components["schemas"]["ResourceService.Application.Contracts.Resources.ReservationData"][];
            /** Format: uuid */
            caseId?: string | null;
            activeRestPeriod?: components["schemas"]["ResourceService.Application.Contracts.Employees.EmployeeRestPeriodModel"];
            canWorkOnExtraShifts?: boolean;
            /** Format: int32 */
            extraShiftsCount?: number;
            canTravel?: boolean;
            /** Format: int32 */
            travelShiftsCount?: number;
            currentDeploymentData?: components["schemas"]["ResourceService.Application.Contracts.Employees.CurrentDeploymentData"];
            /** Format: uuid */
            liverSurgeonRegionId?: string | null;
            /** Format: uuid */
            heartLungsSurgeonRegionId?: string | null;
            affiliation?: components["schemas"]["ResourceService.Application.Contracts.Employees.AffiliationData"];
            contractorCertifications?: components["schemas"]["ResourceService.Application.Contracts.Employees.ContractorCertificationData"][];
            trackedLocation?: components["schemas"]["ResourceService.Application.Contracts.Employees.TrackedLocationModel"];
            clinicalCoordinatorType?: components["schemas"]["ResourceService.Domain.Contracts.Scheduler.Enums.CCResourceType"];
            clinicalSpecialistShiftGroupType?: components["schemas"]["ResourceService.Domain.Contracts.Scheduler.Enums.CSHolidayDutyGroup"];
            deploymentDatas?: components["schemas"]["ResourceService.Application.Contracts.Employees.DeploymentData"][];
            isContractor?: boolean;
            trialPrograms?: components["schemas"]["ResourceService.Application.Contracts.TrialPrograms.TrialProgramResponse"][];
        };
        /** EmployeeIdData */

        "ResourceService.Application.Contracts.Scheduler.QueryModels.Surgeon.SScheduleSegment": {
            /**
             * Format: date-time
             * @description Schedule fragment start date, inclusive
             */
            from: string;
            /**
             * Format: date-time
             * @description Schedule fragment end date, inclusive
             */
            to: string;
            /**
             * @description Shifts of clinical specialists grouped by clinical specialist id.
             *     Key is clinical specialist id.
             */
            resourcesShifts: {
                [key: string]: components["schemas"]["ResourceService.Application.Contracts.Scheduler.QueryModels.Surgeon.SResourceScheduleSegment"];
            } | null;
        };
        /**
         * SShift
         * @description Clinical specialist shift
         */

        "ResourceService.Application.Contracts.Scheduler.QueryModels.ClinicalSpecialist.CSScheduleSegment": {
            /**
             * Format: date-time
             * @description Schedule fragment start date, inclusive
             */
            from: string;
            /**
             * Format: date-time
             * @description Schedule fragment end date, inclusive
             */
            to: string;
            /**
             * @description Shifts of clinical specialists grouped by clinical specialist id.
             *     Key is clinical specialist id.
             */
            resourcesShifts: {
                [key: string]: components["schemas"]["ResourceService.Application.Contracts.Scheduler.QueryModels.ClinicalSpecialist.CSResourceScheduleSegment"];
            } | null;
        };
        /**
         * CSShift
         * @description Clinical specialist shift
         */

        "ResourceService.Application.Contracts.Scheduler.QueryModels.Surgeon.SRegion": {
            /**
             * Format: uuid
             * @description Region id
             */
            id: string;
            /** @description Region display name */
            name: string | null;
            /** @description List of hubs belonging to this region. */
            hubs: components["schemas"]["ResourceService.Application.Contracts.Scheduler.QueryModels.Hub"][];
            /** @description List of organs supported by regions */
            organs: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
        };
        /**
         * SResource
         * @description Information about clinical specialist - type of Transmedics resource
         */

        "ResourceService.Application.Contracts.OcsConsoles.OcsConsoleData": {
            /** Format: uuid */
            id: string;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            modifiedAt: string;
            ocsConsoleName: string | null;
            serialNumber: string | null;
            serialNumberPrefix: string | null;
            fullSerialNumber: string | null;
            caseNumber: string | null;
            /** Format: uuid */
            nopHub: string | null;
            organType: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"];
            status: components["schemas"]["ResourceService.Domain.Contracts.Enums.OcsConsoleStatus"];
            isInMaintenance: boolean;
            /** Format: int32 */
            lastInUseDaysAgo: number | null;
            reservations: components["schemas"]["ResourceService.Application.Contracts.Resources.ReservationData"][];
            /** Format: uuid */
            caseId: string | null;
            caseName: string | null;
            logoPath: string | null;
            trialProgram: components["schemas"]["ResourceService.Application.Contracts.TrialPrograms.TrialProgramResponse"];
        };
        /** Coordinator */

        "ResourceService.Application.Contracts.Resources.ReservationData": {
            /** Format: uuid */
            caseId: string;
            caseName: string | null;
            status: components["schemas"]["ResourceService.Domain.Contracts.Enums.ResourceStatus"];
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            modifiedAt: string | null;
        };
        /** ResourcesAvailibilityData */

        "ResourceService.Application.Contracts.Employees.EmployeeRestPeriodModel": {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            employeeId: string;
            /** Format: date-time */
            restStartTime: string;
            /** Format: int32 */
            restDurationInHours: number;
            /** Format: date-time */
            restEndTime: string;
            /** Format: date-time */
            restCancellationTime: string | null;
            /** Format: date-time */
            actualRestEndTime: string;
            /** Format: uuid */
            caseId: string | null;
            caseName: string | null;
        };
        /** EmployeesReservationsData */

        "ResourceService.Application.Contracts.Employees.CurrentDeploymentData": {
            /** Format: int32 */
            lastCallDaysAgo: number;
            /** Format: int32 */
            successfulCasesLastThirtyDays: number;
            /** Format: int32 */
            allCasesLastThirtyDays: number;
        };
        /** DeploymentData */

        "ResourceService.Application.Contracts.Employees.AffiliationData": {
            affiliationType: components["schemas"]["ResourceService.Domain.Contracts.Enums.AffiliationType"];
            /** Format: uuid */
            txCenterId: string | null;
            /** Format: uuid */
            opoId: string | null;
        };
        /** CertificatesData */

        "ResourceService.Application.Contracts.Employees.ContractorCertificationData": {
            organType: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"];
            /** Format: date-time */
            certificationDate: string;
        };
        /** CurrentDeploymentData */

        "ResourceService.Application.Contracts.Employees.TrackedLocationModel": {
            /** Format: uuid */
            employeeId: string;
            address: string | null;
            /** Format: double */
            latitude?: number;
            /** Format: double */
            longitude?: number;
            /** Format: date-time */
            trackedTime?: string;
        };
        /**
         * EmployeeDetails
         * @description Represents an employee's details to be used for GCC passengers info.
         */

        "ResourceService.Application.Contracts.Employees.DeploymentData": {
            /** Format: int32 */
            lastCallDaysAgo: number;
            organType: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"];
            donorType: components["schemas"]["ResourceService.Domain.Contracts.Enums.Donor"];
        };
        /** EmployeeAvailabilityData */

        "ResourceService.Application.Contracts.TrialPrograms.TrialProgramResponse": {
            /** Format: uuid */
            id: string;
            name: string | null;
            organ: string | null;
            isActive: boolean;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            modifiedAt: string;
        };
        /** SignedUrlData */

        "ResourceService.Application.Contracts.Scheduler.QueryModels.Surgeon.SResourceScheduleSegment": {
            resource: components["schemas"]["ResourceService.Application.Contracts.Scheduler.QueryModels.Surgeon.SResource"];
            /**
             * @description Resource shifts by days.
             *     Key is day.
             */
            days: {
                [key: string]: components["schemas"]["ResourceService.Application.Contracts.Scheduler.QueryModels.Surgeon.SShift"];
            } | null;
        };
        /**
         * SScheduleNexusSegment
         * @description Surgeon schedule segment for Nexus view with regions and resource availability
         */

        "ResourceService.Application.Contracts.Scheduler.QueryModels.ClinicalSpecialist.CSResourceScheduleSegment": {
            resource: components["schemas"]["ResourceService.Application.Contracts.Scheduler.QueryModels.ClinicalSpecialist.CSResource"];
            /**
             * @description Resource shifts by days.
             *     Key is day.
             */
            days: {
                [key: string]: components["schemas"]["ResourceService.Application.Contracts.Scheduler.QueryModels.ClinicalSpecialist.CSShift"];
            } | null;
        };
        /**
         * CSScheduleNexusSegment
         * @description Clinical specialist schedule for Nexus view - includes regions and resource availability
         */

        "ResourceService.Application.Contracts.Scheduler.QueryModels.Hub": {
            /**
             * Format: uuid
             * @description Hub id
             */
            id: string;
            /**
             * Format: uuid
             * @description Region Id
             */
            regionId: string;
            /** @description Hub code */
            code: string | null;
            /** @description Hub display name */
            name: string | null;
            /** @description Hub timezone */
            timezone: string | null;
        };
        /**
         * MyPeriodSchedule
         * @description Monthly schedule information for clinical specialist for the clinical specialist viewing the schedule.
         */

        "ResourceService.Domain.Contracts.Enums.OcsConsoleStatus": ResourceServiceDomainContractsEnumsOcsConsoleStatus;
        /**
         * Organ
         * @description Human organ
         * @enum {string}
         */

        "ResourceService.Domain.Contracts.Enums.ResourceStatus": ResourceServiceDomainContractsEnumsResourceStatus;
        /**
         * ScheduleHrSystemConflictType
         * @description Represents the type of conflict that can occur when processing workday shift types.
         * @enum {string}
         */

        "ResourceService.Domain.Contracts.Enums.Donor": ResourceServiceDomainContractsEnumsDonor;
        /**
         * DriverAffiliationType
         * @enum {string}
         */

        "ResourceService.Application.Contracts.Scheduler.QueryModels.Surgeon.SResource": {
            /**
             * Format: uuid
             * @description Resource id
             */
            id: string;
            /** @description FirstName */
            firstName: string | null;
            /** @description LastName */
            lastName: string | null;
            /** @description Link to profile image */
            profilePhoto: string | null;
            /** @description Resource phone number */
            phoneNumber: string | null;
            /** @description List of certificates from the bodies with which the specialist can work. */
            organs: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            /**
             * Format: uuid
             * @description The identifier of the region to which this specialist belongs.
             */
            regionId: string | null;
            /**
             * Format: uuid
             * @description The identifier of the hub to which this specialist belongs.
             */
            hubId: string | null;
            /** @description Resource hub timezone */
            timezone: string | null;
            group: components["schemas"]["ResourceService.Domain.Contracts.Scheduler.Enums.SurgeonGroup"];
        };
        /**
         * SResourceScheduleNexusSegment
         * @description Schedule for single surgeon with availability information for Nexus view
         */

        "ResourceService.Application.Contracts.Scheduler.QueryModels.Surgeon.SShift": {
            /**
             * Format: uuid
             * @description The schedule identifier to which the shift belongs.
             */
            scheduleId: string;
            /**
             * Format: date-time
             * @description The day on which the work shift takes place.
             */
            day: string;
            /**
             * Format: date-time
             * @description The start timestamp of the shift.
             */
            from: string;
            /**
             * Format: date-time
             * @description The end timestamp of the shift.
             */
            to: string;
            /**
             * Format: uuid
             * @description The ID of the resource that is scheduled to work this shift.
             */
            resourceId: string;
            shiftStatus: components["schemas"]["ResourceService.Domain.Contracts.Scheduler.Enums.ShiftStatus"];
            /** @description True is this shift can be changed manually */
            isEditable: boolean;
            /** @description True if this shift is placed on the pre (preliminary) schedule. */
            isPreSchedule: boolean;
            fixationType: components["schemas"]["ResourceService.Domain.Contracts.Scheduler.Enums.ShiftFixationType"];
            /** @description True if the shift source is HrSystem. */
            isHrShift: boolean;
            shiftType: components["schemas"]["ResourceService.Domain.Contracts.Scheduler.Enums.SShiftType"];
            /** @description List of organs, for which this shift is intended */
            organs: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            /**
             * Format: uuid
             * @description The region id where the shift takes place.
             */
            regionId: string | null;
            /** @description Represents a collection of time intervals during which the resource will be unavailable during a shift. */
            unavailabilities: components["schemas"]["ResourceService.Application.Contracts.Scheduler.QueryModels.Surgeon.Unavailability"][];
            /** @description True if the shift occurs in a non-native region. */
            isTravel: boolean;
        };
        /** Unavailability */

        "ResourceService.Application.Contracts.Scheduler.QueryModels.ClinicalSpecialist.CSResource": {
            /**
             * Format: uuid
             * @description Resource id
             */
            id: string;
            /** @description FirstName */
            firstName: string | null;
            /** @description LastName */
            lastName: string | null;
            /** @description Link to profile image */
            profilePhoto: string | null;
            /** @description Resource phone number */
            phoneNumber: string | null;
            /** @description List of certificates from the bodies with which the specialist can work. */
            organs: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            /** @description List of certificates from the bodies with which the specialist can work as phone support lead. */
            phoneSupportOrgans: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            /** @description List of certificates from the bodies with which the specialist can work as shadow. */
            shadowOrgans: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            /** @description List of certificates from the bodies with which the specialist can work as proctor. */
            proctorOrgans: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            /** @description Indicates that a clinical specialist can provide telephone support. */
            canPhoneSupport: boolean;
            /**
             * Format: uuid
             * @description The identifier of the region to which this specialist belongs.
             */
            regionId: string | null;
            /**
             * Format: uuid
             * @description The identifier of the hub to which this specialist belongs.
             */
            hubId: string | null;
        };
        /**
         * CSResourceScheduleNexusSegment
         * @description Schedule for single clinical specialist with availability information for Nexus view
         */

        "ResourceService.Application.Contracts.Scheduler.QueryModels.ClinicalSpecialist.CSShift": {
            /**
             * Format: uuid
             * @description The schedule identifier to which the shift belongs.
             */
            scheduleId: string;
            /**
             * Format: date-time
             * @description The day on which the work shift takes place.
             */
            day: string;
            /**
             * Format: date-time
             * @description The start timestamp of the shift.
             */
            from: string;
            /**
             * Format: date-time
             * @description The end timestamp of the shift.
             */
            to: string;
            /**
             * Format: uuid
             * @description The ID of the resource that is scheduled to work this shift.
             */
            resourceId: string;
            shiftStatus: components["schemas"]["ResourceService.Domain.Contracts.Scheduler.Enums.ShiftStatus"];
            /** @description True is this shift can be changed manually */
            isEditable: boolean;
            /** @description True if this shift is placed on the pre (preliminary) schedule. */
            isPreSchedule: boolean;
            fixationType: components["schemas"]["ResourceService.Domain.Contracts.Scheduler.Enums.ShiftFixationType"];
            /** @description True if the shift source is HrSystem. */
            isHrShift: boolean;
            shiftType: components["schemas"]["ResourceService.Domain.Contracts.Scheduler.Enums.CSShiftType"];
            /** @description List of organs, for which this shift is intended */
            organs: components["schemas"]["ResourceService.Domain.Contracts.Enums.Organ"][];
            /**
             * Format: uuid
             * @description The region id where the shift takes place.
             */
            regionId: string | null;
            /**
             * Format: uuid
             * @description The hub id where the shift takes place.
             */
            hubId: string | null;
            /** @description Shift is not located in clinical specialist base location */
            isTravel?: boolean;
            /**
             * @description This shift exceeds the monthly norm for the number of shifts of this type,
             *     but the employee agrees to take additional shifts.
             */
            isExtra?: boolean;
        };
        /** CompositeShift[CCShiftType] */

        "ResourceService.Domain.Contracts.Scheduler.Enums.SurgeonGroup": ResourceServiceDomainContractsSchedulerEnumsSurgeonGroup;
        /**
         * CCCustomRule
         * @description Custom work rule for clinical coordinator
         */

        "ResourceService.Domain.Contracts.Scheduler.Enums.ShiftStatus": ResourceServiceDomainContractsSchedulerEnumsShiftStatus;
        /**
         * SurgeonGroup
         * @description Surgeon group
         * @enum {string}
         */

        "ResourceService.Domain.Contracts.Scheduler.Enums.ShiftFixationType": ResourceServiceDomainContractsSchedulerEnumsShiftFixationType;
        /**
         * ShiftStatus
         * @description Shift status, describes the life cycle of a shift.
         * @enum {string}
         */

        "ResourceService.Domain.Contracts.Scheduler.Enums.SShiftType": ResourceServiceDomainContractsSchedulerEnumsSShiftType;
        /**
         * ScheduleFillingState
         * @description Schedule filling state
         * @enum {string}
         */

        "ResourceService.Application.Contracts.Scheduler.QueryModels.Surgeon.Unavailability": {
            /** Format: date-time */
            from: string;
            /** Format: date-time */
            to: string;
        };
        /** TrialProgramResponse */

        "ResourceService.Domain.Contracts.Scheduler.Enums.CSShiftType": ResourceServiceDomainContractsSchedulerEnumsCSShiftType;
        /**
         * OMSShiftType
         * @description Type of Organ Management Specialist shift.
         * @enum {string}
         */

"RouteService.ApiContracts.Requests.CaseLogistics.GetByCaseIdsRequest": {
            caseIds: string[];
        };
        /** CalculateGroundRouteDistanceDetailedRequest */

        "RouteService.ApiContracts.Responses.CaseLogistics.CaseLogisticsResponse": {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            caseId: string;
            logisticsProviders: components["schemas"]["RouteService.ApiContracts.Responses.CaseLogistics.Providers.LogisticsProviderResponse"][];
            resources: components["schemas"]["RouteService.ApiContracts.Responses.CaseLogistics.Resources.IResourceResponse"][];
            locations: components["schemas"]["RouteService.ApiContracts.Responses.CaseLogistics.Locations.ILocationResponse"][];
            routes: components["schemas"]["RouteService.ApiContracts.Responses.CaseLogistics.Routes.LogisticsRouteResponse"][];
            needAviationApproval: boolean | null;
            /** Format: int64 */
            version: number;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            modifiedAt: string;
            /** Format: date-time */
            archivedAt: string | null;
            archivedReason: string | null;
            isTmdxDriveCompatible: boolean;
        };
        /** IRouteLegResponse */

        "RouteService.ApiContracts.Responses.CaseLogistics.Providers.LogisticsProviderResponse": {
            /** Format: uuid */
            id: string;
            name: string | null;
            providerType: components["schemas"]["RouteService.Domain.Contracts.Enums.LogisticProviderType"];
            /** Format: date-time */
            createdAt: string;
        };
        /** IResourceResponse */

        "RouteService.ApiContracts.Responses.CaseLogistics.Resources.IResourceResponse": {
            /** Format: uuid */
            readonly resourceId: string;
            resourceType: components["schemas"]["RouteService.Domain.Contracts.Enums.LegResourceType"];
        };
        /** LogisticsRouteResponse */

        "RouteService.ApiContracts.Responses.CaseLogistics.Locations.ILocationResponse": {
            /** Format: uuid */
            readonly id: string;
            location: components["schemas"]["RouteService.ApiContracts.Responses.CaseLogistics.ValueObjects.LocationResponse"];
            locationType: components["schemas"]["RouteService.Domain.Contracts.Enums.LegLocationType"];
            /** Format: date-time */
            readonly createdAt: string;
        };
        /** LogisticsProviderResponse */

        "RouteService.ApiContracts.Responses.CaseLogistics.Routes.LogisticsRouteResponse": {
            /** Format: uuid */
            id: string;
            routeType: components["schemas"]["RouteService.Domain.Contracts.Enums.RouteType"];
            transportationType: components["schemas"]["RouteService.Domain.Contracts.Enums.TransportationType"];
            departureHub: components["schemas"]["RouteService.ApiContracts.Responses.CaseLogistics.ValueObjects.LocationReferenceResponse"];
            arrivalHub: components["schemas"]["RouteService.ApiContracts.Responses.CaseLogistics.ValueObjects.LocationReferenceResponse"];
            legs: components["schemas"]["RouteService.ApiContracts.Responses.CaseLogistics.Legs.IRouteLegResponse"][];
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            modifiedAt: string;
        };
        /** LocationReferenceResponse */

        "RouteService.Domain.Contracts.Enums.LogisticProviderType": RouteServiceDomainContractsEnumsLogisticProviderType;
        /**
         * RouteSnapshotType
         * @enum {string}
         */

        "RouteService.Domain.Contracts.Enums.LegResourceType": RouteServiceDomainContractsEnumsLegResourceType;
        /**
         * LegType
         * @enum {string}
         */

        "RouteService.ApiContracts.Responses.CaseLogistics.ValueObjects.LocationResponse": {
            country: string | null;
            state: string | null;
            city: string | null;
            addressLine: string | null;
            postalCode: string | null;
            timezone: string | null;
            /** Format: double */
            latitude: number | null;
            /** Format: double */
            longitude: number | null;
        };
        /** ResourceReferenceResponse */

        "RouteService.Domain.Contracts.Enums.LegLocationType": RouteServiceDomainContractsEnumsLegLocationType;
        /**
         * LegResourceType
         * @enum {string}
         */

        "RouteService.Domain.Contracts.Enums.RouteType": RouteServiceDomainContractsEnumsRouteType;
        /**
         * SegmentType
         * @enum {string}
         */

        "RouteService.Domain.Contracts.Enums.TransportationType": RouteServiceDomainContractsEnumsTransportationType;
        /**
         * VehicleType
         * @enum {string}
         */

        "RouteService.ApiContracts.Responses.CaseLogistics.ValueObjects.LocationReferenceResponse": {
            /** Format: uuid */
            locationId: string;
            locationType: components["schemas"]["RouteService.Domain.Contracts.Enums.LegLocationType"];
        };
        /** LocationResponse */

        "RouteService.ApiContracts.Responses.CaseLogistics.Legs.IRouteLegResponse": {
            /** Format: uuid */
            readonly id: string;
            segmentType: components["schemas"]["RouteService.Domain.Contracts.Enums.SegmentType"];
            readonly resources: components["schemas"]["RouteService.ApiContracts.Responses.CaseLogistics.ValueObjects.ResourceReferenceResponse"][];
            /** Format: date-time */
            readonly createdAt: string;
            /** Format: date-time */
            readonly modifiedAt: string;
            legType: components["schemas"]["RouteService.Domain.Contracts.Enums.LegType"];
        };
        /** ILocationResponse */

        "RouteService.Domain.Contracts.Enums.SegmentType": RouteServiceDomainContractsEnumsSegmentType;
        /**
         * TransportationType
         * @enum {string}
         */

        "RouteService.ApiContracts.Responses.CaseLogistics.ValueObjects.ResourceReferenceResponse": {
            /** Format: uuid */
            resourceId: string;
            resourceType: components["schemas"]["RouteService.Domain.Contracts.Enums.LegResourceType"];
        };
        /** DeviceTrackingGraphResponse */

        "RouteService.Domain.Contracts.Enums.LegType": RouteServiceDomainContractsEnumsLegType;
        /**
         * LogisticProviderType
         * @enum {string}
         */
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}

export enum CaseServiceDomainContractsEnumsAberrantAnatomyType {
    ReplacedRightOrAccessoryRightHepaticArtery = "ReplacedRightOrAccessoryRightHepaticArtery",
    ReplacedLeftOrAccessoryLeftHepaticArtery = "ReplacedLeftOrAccessoryLeftHepaticArtery",
    Other = "Other"
}
export enum CaseServiceDomainContractsEnumsAcceptanceCriteriaBiopsyType {
    Yes = "Yes",
    BasedOnVisual = "BasedOnVisual"
}
export enum CaseServiceDomainContractsEnumsAnswer {
    Yes = "Yes",
    No = "No",
    LUNGGuard = "LUNGGuard",
    BAROGuard = "BAROGuard",
    StandardColdPreservation = "StandardColdPreservation",
    Other = "Other",
    PartA = "PartA",
    PartB = "PartB",
    Paragonix = "Paragonix",
    SherpaPak = "SherpaPak",
    IceCooler = "IceCooler"
}
export enum CaseServiceDomainContractsEnumsApiContractClinicalItemType {
    NRPStart = "NRPStart",
    ScheduledDonorORStartTime = "ScheduledDonorORStartTime",
    DonorInOR = "DonorInOR",
    RecordDelay = "RecordDelay",
    Heparin = "Heparin",
    SkinIncisionTime = "SkinIncisionTime",
    CrossClampTimeFlushTime = "CrossClampTimeFlushTime",
    FinalFlush = "FinalFlush",
    DeployedToDonorHospital = "DeployedToDonorHospital",
    AtDonorHospital = "AtDonorHospital",
    OrganOnOCS = "OrganOnOCS",
    LeavingDonorHospital = "LeavingDonorHospital",
    ArrivalAtRecipientHospital = "ArrivalAtRecipientHospital",
    OrganAccepted = "OrganAccepted",
    LeavingRecipientHospital = "LeavingRecipientHospital",
    SpecialistIsDone = "SpecialistIsDone",
    PFOValveCondition = "PFOValveCondition",
    OffOCS = "OffOCS",
    Priming = "Priming",
    CardiacArrest = "CardiacArrest",
    PreOCSFlush = "PreOCSFlush",
    AtHub = "AtHub",
    CheckInOCSDevice = "CheckInOCSDevice",
    DonorDidNotExpireInTime = "DonorDidNotExpireInTime",
    Turndown = "Turndown",
    OCSDeviceDeployment = "OCSDeviceDeployment",
    OneLungTurndown = "OneLungTurndown",
    WithdrawalOfLifeSupportTime = "WithdrawalOfLifeSupportTime",
    DryRun = "DryRun",
    BloodAvailabilityCheck = "BloodAvailabilityCheck",
    DonorLabelsCheck = "DonorLabelsCheck",
    BronchCartAndSuctionCheck = "BronchCartAndSuctionCheck",
    ReintubationPersonalCheck = "ReintubationPersonalCheck",
    OnSiteCoordinatorsContacts = "OnSiteCoordinatorsContacts",
    PickUpOfOrganLabelAndTissueSamples = "PickUpOfOrganLabelAndTissueSamples",
    IceForTheOCSCoolerPriorDeparture = "IceForTheOCSCoolerPriorDeparture",
    CysticDuct = "CysticDuct",
    ResearchBloodSamples = "ResearchBloodSamples",
    TeamHuddle = "TeamHuddle",
    SupplementalOrgan = "SupplementalOrgan",
    Bile = "Bile",
    WithdrawalOfLifeSupport = "WithdrawalOfLifeSupport",
    NRPApplicabilityAndType = "NRPApplicabilityAndType",
    DeathDeclarationTime = "DeathDeclarationTime",
    PostFlushLungsPhoto = "PostFlushLungsPhoto",
    Stabilization = "Stabilization",
    PreOCSBloodSample = "PreOCSBloodSample",
    BloodSample = "BloodSample",
    LiverOnABackBench = "LiverOnABackBench",
    AnatomyPhotos = "AnatomyPhotos",
    PostFlushBronch = "PostFlushBronch",
    BronchInSitu = "BronchInSitu",
    BronchVideoOnTheOCS = "BronchVideoOnTheOCS",
    PFRatioInSitu = "PFRatioInSitu",
    PFRatioOnOCSDonorHospital = "PFRatioOnOCSDonorHospital",
    PFRatioOnOCSTXCenter = "PFRatioOnOCSTXCenter",
    FinalBronchVideoAtTheRecipientHospital = "FinalBronchVideoAtTheRecipientHospital",
    OffOCSPhotoAndVideo = "OffOCSPhotoAndVideo",
    OnOCSVideo = "OnOCSVideo",
    InSituVideoOfHeart = "InSituVideoOfHeart",
    VisualInspection = "VisualInspection",
    FinalPhysicalExamPictureOrVideo = "FinalPhysicalExamPictureOrVideo",
    FinalCheck = "FinalCheck",
    ReconstructionVideosPhotos = "ReconstructionVideosPhotos",
    DonorBiopsyReport = "DonorBiopsyReport",
    TxOCSBiopsy = "TxOCSBiopsy",
    LiverReconstructionQuestionnaire = "LiverReconstructionQuestionnaire",
    LiverAnatomyQuestionnaire = "LiverAnatomyQuestionnaire",
    VitalUpdates = "VitalUpdates",
    BloodCollection = "BloodCollection",
    HeartPassOption = "HeartPassOption",
    PerfusionTerminationOption = "PerfusionTerminationOption",
    SCSTerminationOption = "SCSTerminationOption",
    DonorSpecimenHandoff = "DonorSpecimenHandoff",
    MultipleDonorSpecimenHandoff = "MultipleDonorSpecimenHandoff",
    ServiceConfirmation = "ServiceConfirmation",
    DiscardConfirmationForm = "DiscardConfirmationForm",
    OrganMonitoring = "OrganMonitoring",
    Randomization = "Randomization",
    OrganOnSCS = "OrganOnSCS",
    OffSCS = "OffSCS",
    OrganApproved = "OrganApproved",
    OrganDeclined = "OrganDeclined"
}
export enum CaseServiceDomainContractsEnumsAssignedUserLabel {
    Primary = "Primary",
    Relief = "Relief",
    Proctor = "Proctor",
    Shadow = "Shadow"
}
export enum CaseServiceDomainContractsEnumsAssistanceType {
    TrainedProcurementSurgeon = "TrainedProcurementSurgeon",
    TrainedSurgicalAssistant = "TrainedSurgicalAssistant",
    SurgicalResidentOrFellow = "SurgicalResidentOrFellow",
    UnspecializedSurgicalAssistant = "UnspecializedSurgicalAssistant",
    None = "None"
}
export enum CaseServiceDomainContractsEnumsBacktableInjuryType {
    ArterialInjury = "ArterialInjury",
    BiliaryInjury = "BiliaryInjury",
    VenousInjury = "VenousInjury"
}
export enum CaseServiceDomainContractsEnumsBloodGroupAbo {
    None = "None",
    A = "A",
    B = "B",
    AB = "AB",
    O = "O"
}
export enum CaseServiceDomainContractsEnumsCaseDataSyncStatus {
    NotStarted = "NotStarted",
    Succeed = "Succeed"
}
export enum CaseServiceDomainContractsEnumsCaseRandomizationResultFilter {
    NotRandomized = "NotRandomized",
    OCS = "OCS",
    SCS = "SCS"
}
export enum CaseServiceDomainContractsEnumsCaseStatus {
    None = "None",
    Draft = "Draft",
    TXCenterDraft = "TXCenterDraft",
    ClinicalScreening = "ClinicalScreening",
    Declined = "Declined",
    ServiceDeclined = "ServiceDeclined",
    New = "New",
    Accepted = "Accepted",
    PendingLogistics = "PendingLogistics",
    OrTimeConfirmed = "OrTimeConfirmed",
    ResourceDeployed = "ResourceDeployed",
    AtDonorHospital = "AtDonorHospital",
    OrganOnOCS = "OrganOnOCS",
    AtTXCenter = "AtTXCenter",
    OrganOffOCS = "OrganOffOCS",
    ServiceCompleted = "ServiceCompleted",
    DeployedToTXCenter = "DeployedToTXCenter",
    ReturningToBase = "ReturningToBase",
    ResourcesBooked = "ResourcesBooked",
    Finished = "Finished",
    Closed = "Closed",
    Deleted = "Deleted",
    OpoDraft = "OpoDraft"
}
export enum CaseServiceDomainContractsEnumsCauseOfDeath {
    Anoxia = "Anoxia",
    Cerebrovascular = "Cerebrovascular",
    HeadTrauma = "HeadTrauma",
    CNSTumor = "CNSTumor",
    Other = "Other"
}
export enum CaseServiceDomainContractsEnumsCreationSide {
    Tmdx = "Tmdx",
    Customer = "Customer",
    Opo = "Opo"
}
export enum CaseServiceDomainContractsEnumsCustomerCaseStatus {
    Undefined = "Undefined",
    Draft = "Draft",
    UnderClinicalScreening = "UnderClinicalScreening",
    CaseInitiatedForOCS = "CaseInitiatedForOCS",
    CaseDeclined = "CaseDeclined",
    LogisticsQuoteReceived = "LogisticsQuoteReceived",
    LogisticsQuoteDeclined = "LogisticsQuoteDeclined",
    LogisticsQuoteRecalled = "LogisticsQuoteRecalled",
    TeamDeploymentInProgress = "TeamDeploymentInProgress",
    AtDonorHospital = "AtDonorHospital",
    CaseCanceled = "CaseCanceled",
    TransplantNotCompleted = "TransplantNotCompleted",
    OrganOnOCS = "OrganOnOCS",
    OrganInTransit = "OrganInTransit",
    OrganAtTXCenter = "OrganAtTXCenter",
    OrganOffOCS = "OrganOffOCS",
    NOPServiceCompleted = "NOPServiceCompleted",
    NOPInvoiceReceived = "NOPInvoiceReceived",
    CaseClosed = "CaseClosed",
    NOPInvoiceUpdated = "NOPInvoiceUpdated"
}
export enum CaseServiceDomainContractsEnumsDeclineSourceType {
    Case = "Case",
    Service = "Service"
}
export enum CaseServiceDomainContractsEnumsDispositionReasonType {
    NoClinicalSpecialists = "NoClinicalSpecialists",
    NoSurgeon = "NoSurgeon",
    NoPlanes = "NoPlanes",
    NoGroundTransport = "NoGroundTransport",
    TooShortNotice = "TooShortNotice",
    ByTxCenter = "ByTxCenter",
    DonationWithdrawnByOPO = "DonationWithdrawnByOPO",
    OCSContraindicationOrNotSuitable = "OCSContraindicationOrNotSuitable",
    DonorDidNotProgressToDeathWithinEstablishedTimeframe = "DonorDidNotProgressToDeathWithinEstablishedTimeframe",
    OCSContraindication = "OCSContraindication",
    DeviceMalfunction = "DeviceMalfunction",
    ClinicallyDeemedUnacceptableForTransplantation = "ClinicallyDeemedUnacceptableForTransplantation",
    DeclinedDueToDonorFactors = "DeclinedDueToDonorFactors",
    DeclinedDueToRecipientFactors = "DeclinedDueToRecipientFactors",
    DeclinedDueToFailureOfTheOPOToAllocateTheOrgan = "DeclinedDueToFailureOfTheOPOToAllocateTheOrgan",
    DeclinedDueToTogisticsReason = "DeclinedDueToTogisticsReason",
    DeclinedDueToUnrepairableSurgicalInjury = "DeclinedDueToUnrepairableSurgicalInjury",
    DeclinedDueToMissedAPreExistingInternalAirLeak = "DeclinedDueToMissedAPreExistingInternalAirLeak",
    Other = "Other",
    CancelledByTransMedics = "CancelledByTransMedics",
    WithdrawnByOPO = "WithdrawnByOPO",
    OrganNotSuitableForOCS = "OrganNotSuitableForOCS",
    ErroneousCase = "ErroneousCase",
    DCDDonorDidNotExpire = "DCDDonorDidNotExpire",
    SurgicalError = "SurgicalError",
    TurndownByTxCenter = "TurndownByTxCenter"
}
export enum CaseServiceDomainContractsEnumsDispositionSpecificationType {
    None = "None",
    DonorReasons = "DonorReasons",
    RecipientReasons = "RecipientReasons",
    LogisticsCosts = "LogisticsCosts",
    AcceptedAlternateDonor = "AcceptedAlternateDonor",
    ChangedToAnAlternatePreservationMethod = "ChangedToAnAlternatePreservationMethod",
    DonorQuality = "DonorQuality",
    OrganNotViable = "OrganNotViable",
    LogisticalIssues = "LogisticalIssues",
    TXCenterAcceptanceCriteria = "TXCenterAcceptanceCriteria",
    AlternatePreservationMethod = "AlternatePreservationMethod",
    OCSContraindicationOrNotSuitable = "OCSContraindicationOrNotSuitable",
    NoClinicalSpecialists = "NoClinicalSpecialists",
    NoSurgeon = "NoSurgeon",
    NoDevice = "NoDevice",
    TooShortNotice = "TooShortNotice",
    NoGroundTransport = "NoGroundTransport",
    NoPlanes = "NoPlanes",
    Other = "Other"
}
export enum CaseServiceDomainContractsEnumsDonorGender {
    Male = "Male",
    Female = "Female",
    Other = "Other"
}
export enum CaseServiceDomainContractsEnumsDonorType {
    None = "None",
    DBD = "DBD",
    DCD = "DCD"
}
export enum CaseServiceDomainContractsEnumsFlushType {
    Good = "Good",
    DidNotDlushWell = "DidNotDlushWell"
}
export enum CaseServiceDomainContractsEnumsGetCasesOrderBy {
    None = "None",
    DonorORTime = "DonorORTime",
    DonorId = "DonorId",
    DonorType = "DonorType",
    CreatedAt = "CreatedAt",
    OrganOnOCSTimestamp = "OrganOnOCSTimestamp",
    TrialProgramName = "TrialProgramName",
    ModifiedAt = "ModifiedAt"
}
export enum CaseServiceDomainContractsEnumsImpactOfInjuryType {
    NoImpact = "NoImpact",
    OrganUsedButInjuryChangedAllocationOrResultedInAlterationToPractice = "OrganUsedButInjuryChangedAllocationOrResultedInAlterationToPractice",
    OrganDeclined = "OrganDeclined"
}
export enum CaseServiceDomainContractsEnumsInvoiceStatus {
    Open = "Open",
    PartiallyCredited = "PartiallyCredited",
    FullyCredited = "FullyCredited",
    PartiallyPaid = "PartiallyPaid",
    Paid = "Paid"
}
export enum CaseServiceDomainContractsEnumsLiverOutcome {
    PlacedOnOCSLiver = "PlacedOnOCSLiver",
    NotPlacedOnOCSLiver = "NotPlacedOnOCSLiver",
    DCDNotPlacedOnOCSLiver = "DCDNotPlacedOnOCSLiver"
}
export enum CaseServiceDomainContractsEnumsLiverQuality {
    NoQualityIssues = "NoQualityIssues",
    Congested = "Congested",
    Steatotic = "Steatotic",
    Cirrhotic = "Cirrhotic",
    CalcifiedVessels = "CalcifiedVessels",
    Other = "Other"
}
export enum CaseServiceDomainContractsEnumsLogisticProviderType {
    TMDX = "TMDX",
    Partner = "Partner",
    TxCenter = "TxCenter",
    SupplementalLiftProvider = "SupplementalLiftProvider",
    TMDXAffiliate = "TMDXAffiliate"
}
export enum CaseServiceDomainContractsEnumsLogisticsProviderType {
    None = "None",
    TMDX = "TMDX",
    PartnerProvider = "PartnerProvider",
    TXCenterProvider = "TXCenterProvider"
}
export enum CaseServiceDomainContractsEnumsLogisticsStatus {
    None = "None",
    Reserved = "Reserved",
    BookingSent = "BookingSent",
    Booked = "Booked",
    DeployedToDonorHospital = "DeployedToDonorHospital",
    AtDonorHospital = "AtDonorHospital",
    RecoveryIsCompleted = "RecoveryIsCompleted",
    DeployedFromDonorHospital = "DeployedFromDonorHospital",
    AtTXCenter = "AtTXCenter",
    DeployedToHub = "DeployedToHub",
    DeployedFromTXCenter = "DeployedFromTXCenter",
    OCSDeployed = "OCSDeployed",
    OCSDone = "OCSDone",
    Done = "Done",
    BookedInMao = "BookedInMao",
    CancelledInMao = "CancelledInMao"
}
export enum CaseServiceDomainContractsEnumsMediaType {
    Photo = "Photo",
    Video = "Video"
}
export enum CaseServiceDomainContractsEnumsNeuroStatus {
    BrainDead = "BrainDead",
    BrainIsNotDead = "BrainIsNotDead",
    PendingBrainDeathDeclaration = "PendingBrainDeathDeclaration"
}
export enum CaseServiceDomainContractsEnumsNoLiverInjuryType {
    IntestinalPerforationWithContamination = "IntestinalPerforationWithContamination",
    KidneyInjury = "KidneyInjury",
    PancreasInjury = "PancreasInjury",
    Other = "Other"
}
export enum CaseServiceDomainContractsEnumsOpoCaseStatus {
    Undefined = "Undefined",
    Draft = "Draft",
    UnderClinicalScreening = "UnderClinicalScreening",
    CaseInitiatedForOCS = "CaseInitiatedForOCS",
    TeamDeploymentInProgress = "TeamDeploymentInProgress",
    AtDonorHospital = "AtDonorHospital",
    OrganOnOCS = "OrganOnOCS",
    CaseDeclined = "CaseDeclined"
}
export enum CaseServiceDomainContractsEnumsOrganApprovalStatus {
    Pending = "Pending",
    Approved = "Approved",
    Declined = "Declined"
}
export enum CaseServiceDomainContractsEnumsOrganOnOcsDeclineReason {
    DonorQuality = "DonorQuality",
    OrganNotViable = "OrganNotViable",
    RecipientReasons = "RecipientReasons",
    LogisticalIssues = "LogisticalIssues",
    TXCenterAcceptanceCriteria = "TXCenterAcceptanceCriteria",
    AlternatePreservationMethod = "AlternatePreservationMethod"
}
export enum CaseServiceDomainContractsEnumsOrganType {
    None = "None",
    Liver = "Liver",
    Heart = "Heart",
    Lungs = "Lungs"
}
export enum CaseServiceDomainContractsEnumsOutcomeStatus {
    ClinicalScreening = "ClinicalScreening",
    ServiceDeclined = "ServiceDeclined",
    Declined = "Declined",
    ServiceCompleted = "ServiceCompleted"
}
export enum CaseServiceDomainContractsEnumsOutcomeType {
    Aborted = "Aborted",
    DryRun = "DryRun",
    Turndown = "Turndown",
    Transplant = "Transplant"
}
export enum CaseServiceDomainContractsEnumsProcurementInjuryType {
    ArterialInjury = "ArterialInjury",
    BiliaryInjury = "BiliaryInjury",
    PortalVeinInjury = "PortalVeinInjury",
    ParenchymalInjury = "ParenchymalInjury",
    Other = "Other"
}
export enum CaseServiceDomainContractsEnumsQuestion {
    RequestedRecoveryForDenovoTrial = "RequestedRecoveryForDenovoTrial",
    DenovoColdStaticPreservationConfirmation = "DenovoColdStaticPreservationConfirmation",
    RequestedRecoveryForEnhanceTrial = "RequestedRecoveryForEnhanceTrial",
    TypeOfEnhanceTrial = "TypeOfEnhanceTrial",
    EnhanceColdStaticPreservationConfirmation = "EnhanceColdStaticPreservationConfirmation"
}
export enum CaseServiceDomainContractsEnumsQuotesQuoteRejectReason {
    NotSuitable = "NotSuitable",
    FullOwnLogistics = "FullOwnLogistics",
    OwnAirLogistics = "OwnAirLogistics",
    OwnGroundLogistics = "OwnGroundLogistics"
}
export enum CaseServiceDomainContractsEnumsQuotesQuoteStatus {
    NoQuote = "NoQuote",
    Created = "Created",
    ApprovedInternally = "ApprovedInternally",
    SentToTxCenter = "SentToTxCenter",
    Approved = "Approved",
    Rejected = "Rejected",
    Recalled = "Recalled"
}
export enum CaseServiceDomainContractsEnumsRandomizationResult {
    OCS = "OCS",
    SCS = "SCS"
}
export enum CaseServiceDomainContractsEnumsResourceLabel {
    Primary = "Primary",
    Relief = "Relief",
    Proctor = "Proctor",
    Shadow = "Shadow"
}
export enum CaseServiceDomainContractsEnumsResourceType {
    None = "None",
    ClinicalSpecialist = "ClinicalSpecialist",
    Surgeon = "Surgeon",
    OCSConsole = "OCSConsole",
    Aircraft = "Aircraft",
    Employee = "Employee"
}
export enum CaseServiceDomainContractsEnumsReviewStatus {
    Approved = "Approved",
    Rejected = "Rejected",
    Recalled = "Recalled",
    WaitingForApproval = "WaitingForApproval",
    NotApplicable = "NotApplicable"
}
export enum CaseServiceDomainContractsEnumsReviewType {
    Quote = "Quote",
    Aviation = "Aviation",
    Ground = "Ground",
    TXCenterQuote = "TXCenterQuote",
    TXCenterService = "TXCenterService"
}
export enum CaseServiceDomainContractsEnumsReviewerType {
    NotDefined = "NotDefined",
    Customer = "Customer",
    Employee = "Employee"
}
export enum CaseServiceDomainContractsEnumsRoutePlanningStatus {
    None = "None",
    RoutePlanning = "RoutePlanning",
    WaitingForAviationApproval = "WaitingForAviationApproval",
    WaitingForQuoteApproval = "WaitingForQuoteApproval",
    RoutePlanningDone = "RoutePlanningDone",
    PendingResourcesBooking = "PendingResourcesBooking",
    ResourcesBooked = "ResourcesBooked"
}
export enum CaseServiceDomainContractsEnumsRouteType {
    Main = "Main",
    DryRun = "DryRun"
}
export enum CaseServiceDomainContractsEnumsServiceType {
    None = "None",
    NopWithTmdxSurgeon = "NopWithTmdxSurgeon",
    NopWithoutTmdxSurgeon = "NopWithoutTmdxSurgeon",
    DirectAcquisition = "DirectAcquisition"
}
export enum CaseServiceDomainContractsEnumsSurgeonCaseSummaryStatus {
    Incomplete = "Incomplete",
    Completed = "Completed"
}
export enum CaseServiceDomainContractsEnumsTurndownOutcome {
    DiscardOrgan = "DiscardOrgan",
    ShipOrgan = "ShipOrgan",
    RellocateOrgan = "RellocateOrgan"
}
export enum CaseServiceDomainContractsEnumsUserType {
    System = "System",
    Employee = "Employee",
    Customer = "Customer",
    OpoUser = "OpoUser"
}
export enum CaseServiceDomainContractsEnumsWarmIschemicTimeType {
    SystolicLessThan80 = "SystolicLessThan80",
    SystolicLessThan50 = "SystolicLessThan50",
    MapLessThan50 = "MapLessThan50",
    SystolicLessThan80SaturationLessThan80 = "SystolicLessThan80SaturationLessThan80"
}
export enum ResourceServiceDomainContractsEnumsAffiliationType {
    TMDXContract = "TMDXContract",
    TXCenter = "TXCenter",
    OPO = "OPO",
    NoContract = "NoContract"
}
export enum ResourceServiceDomainContractsEnumsDonor {
    DBD = "DBD",
    DCD = "DCD"
}
export enum ResourceServiceDomainContractsEnumsEmployeeSearchOrderBy {
    None = "None",
    Name = "Name",
    Position = "Position"
}
export enum ResourceServiceDomainContractsEnumsLocationPreference {
    Base = "Base",
    Home = "Home",
    Affiliation = "Affiliation"
}
export enum ResourceServiceDomainContractsEnumsOcsConsoleStatus {
    Available = "Available",
    OnCase = "OnCase",
    Reserved = "Reserved"
}
export enum ResourceServiceDomainContractsEnumsOrgan {
    Liver = "Liver",
    Heart = "Heart",
    Lungs = "Lungs"
}
export enum ResourceServiceDomainContractsEnumsResourceStatus {
    Done = "Done",
    Canceled = "Canceled",
    Reserved = "Reserved",
    BookingSent = "BookingSent",
    Booked = "Booked",
    BookedInMao = "BookedInMao"
}
export enum ResourceServiceDomainContractsEnumsSize {
    XS = "XS",
    S = "S",
    M = "M",
    L = "L",
    XL = "XL",
    XXL = "XXL"
}
export enum ResourceServiceDomainContractsEnumsStatus {
    All = "All",
    Active = "Active",
    Inactive = "Inactive"
}
export enum ResourceServiceDomainContractsSchedulerEnumsCCResourceType {
    TC1 = "TC1",
    TC2 = "TC2",
    TC3 = "TC3"
}
export enum ResourceServiceDomainContractsSchedulerEnumsCSHolidayDutyGroup {
    GroupA = "GroupA",
    GroupB = "GroupB",
    GroupC = "GroupC"
}
export enum ResourceServiceDomainContractsSchedulerEnumsCSShiftType {
    OnCall = "OnCall",
    AtHub = "AtHub",
    NoCall = "NoCall",
    WeekendOff = "WeekendOff",
    OfficeDay = "OfficeDay",
    Unavailable = "Unavailable",
    Vacation = "Vacation",
    Sick = "Sick",
    PhoneSupport = "PhoneSupport",
    TravelDay = "TravelDay"
}
export enum ResourceServiceDomainContractsSchedulerEnumsSShiftType {
    OnCall = "OnCall",
    NoCall = "NoCall",
    Unavailable = "Unavailable",
    Vacation = "Vacation",
    Sick = "Sick"
}
export enum ResourceServiceDomainContractsSchedulerEnumsShiftFixationType {
    Assigned = "Assigned",
    Preferred = "Preferred",
    Required = "Required"
}
export enum ResourceServiceDomainContractsSchedulerEnumsShiftStatus {
    Actual = "Actual",
    Deprecated = "Deprecated",
    InPlanningProcess = "InPlanningProcess"
}
export enum ResourceServiceDomainContractsSchedulerEnumsSurgeonGroup {
    Liver = "Liver",
    HeartLungs = "HeartLungs"
}
export enum RouteServiceDomainContractsEnumsLegLocationType {
    Hub = "Hub",
    Airport = "Airport",
    Hospital = "Hospital",
    TxCenter = "TxCenter",
    HomeResidence = "HomeResidence",
    Custom = "Custom"
}
export enum RouteServiceDomainContractsEnumsLegResourceType {
    ClinicalSpecialist = "ClinicalSpecialist",
    Surgeon = "Surgeon",
    OCSConsole = "OCSConsole",
    Aircraft = "Aircraft",
    Crew = "Crew"
}
export enum RouteServiceDomainContractsEnumsLegType {
    Air = "Air",
    Ground = "Ground",
    Accommodation = "Accommodation"
}
export enum RouteServiceDomainContractsEnumsLogisticProviderType {
    Tmdx = "Tmdx",
    Partner = "Partner",
    TxCenter = "TxCenter",
    SupplementalLiftProvider = "SupplementalLiftProvider",
    TMDXAffiliate = "TMDXAffiliate"
}
export enum RouteServiceDomainContractsEnumsRouteType {
    Main = "Main",
    DryRun = "DryRun"
}
export enum RouteServiceDomainContractsEnumsSegmentType {
    HubToDonorHospital = "HubToDonorHospital",
    DonorHospitalToTxCenter = "DonorHospitalToTxCenter",
    TxCenterToHub = "TxCenterToHub",
    DonorHospitalToHub = "DonorHospitalToHub",
    Reposition = "Reposition",
    Custom = "Custom",
    ReturnToBase = "ReturnToBase"
}
export enum RouteServiceDomainContractsEnumsTransportationType {
    None = "None",
    Ground = "Ground",
    Air = "Air",
    GroundPlusAir = "GroundPlusAir"
}
export type operations = Record<string, never>;

// Export schemas type for convenience
export type schemas = components['schemas'];
